import directives from './module';
import {Strings} from 'Strings';
import {TranslateSvc} from '../services/TranslateSvc';

directives.filter('uniqueFilter', () => (items: any[], filterOn: string) =>
    _.unique(items, false, (item: any) => item[filterOn])
);

directives.filter('prependHttp', () => (url: string | undefined) => {
        if (Strings.isBlank(url)) return '';
        const withHttp = url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
        return withHttp ? url : 'http://' + url;
    }
);

directives.filter('visibilityExplanation', (TranslateSvc: TranslateSvc) => {
    const visibilities = {
        'public': TranslateSvc.get('visibility.public'),
        'unlisted': TranslateSvc.get('visibility.unlisted'),
        'private': TranslateSvc.get('visibility.private')
    };
    return (visibility: string) => visibilities[(visibility || 'public').toLowerCase()];
});

directives.filter('encodeUrl', () => (url: string) => encodeURIComponent(url));

directives.filter('encodeUsername', () => (username: string) => Strings.encodeUsername(username));

directives.filter('formatNumbers', () =>
    (num: string) => {
        num = num.toString();
        if (num.length >= 5) {
            return num.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return num;
    }
);

directives.filter('removeUrlProtocol', () => (url: string) => Strings.removeUrlProtocol(url));

directives.filter('toCardId', () => {
        const cards = {
            'american express': 'amex',
            'diners club': 'diners'
        };
        return (str: string) =>
            angular.isString(str) ? cards[str] || str : '';
    }
);

directives.filter('parseDate', () => {
        return (str: string): string => {
            if (_.isString(str)) {
                const conventionalDate = str.split('/').reverse().join('/');
                return new Date(conventionalDate).getTime().toString();
            } else {
                return '';
            }
        };
    }
);

directives.filter('stripTags', () => (input: any) => Strings.stripTags(input));

directives.filter('linky', ($sce: ng.ISCEService) => {
    const LINKY_URL_REGEXP =
            /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
        MAILTO_REGEXP = /^mailto:/;

    return (text: string, target: string) => {

        if (!text) return text;
        let match: RegExpMatchArray;
        let raw = text;
        let html: string[] = [];
        let url: string;
        let i: number;
        while ((match = raw.match(LINKY_URL_REGEXP))) {
            // We can not end in these as they are sometimes found at the end of the sentence
            url = match[0];
            // if we did not match ftp/http/www/mailto then assume mailto
            if (!match[2] && !match[4]) {
                url = (match[3] ? 'http://' : 'mailto:') + url;
            }
            i = match.index;
            addText(raw.substr(0, i));
            addLink(url, match[0].replace(MAILTO_REGEXP, ''));
            raw = raw.substring(i + match[0].length);
        }
        addText(raw);
        return $sce.trustAsHtml(html.join(''));

        function addText(text: string) {
            if (text) {
                html.push(text);
            }
        }

        function addLink(url: string, text: string) {
            html.push('<a ');
            if (angular.isDefined(target)) {
                html.push('target="',
                    target,
                    '" ');
            }
            html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
            addText(text);
            html.push('</a>');
        }
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/filters.ts